import { lazy } from 'react';

export const MainSearchResultsPageLazy = lazy(() => import('./MainSearchResultsPage'));
